<template>
  <div class="osBody">
    <div class="osTree" v-show="IfShow === 0">
      <div class="TreeTop">机构筛选</div>
      <el-tree
        :data="osData"
        accordion
        :props="defaultProps"
        node-key="officeId"
        :default-expanded-keys="['1']"
        @node-click="chooseNode"
        class="ElTree"
      >
      </el-tree>
      <div class="TreeDiv" @click="TreeD">
        <img :src="ImgSrc" alt="" srcset="" style="width: 100%; height: 100%" />
      </div>
    </div>
    <!-- </transition> -->
    <div class="osTreeOne" v-show="IfShow === 1">
      <div class="TreeDivOne" @click="TreeD">
        <img :src="ImgSrc" alt="" srcset="" style="width: 100%; height: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonUserProjectTree",
  data() {
    return {
      osData: [],
      AllDate: "",
      defaultProps: { children: "children", label: "officeName" },
      ImgSrc: require("../../assets/images/zuo@3x.png"),
      TreeNum: 1,
      IfShow: 0,
    };
  },
  methods: {
    chooseNode(data) {
      this.$emit("AllData", data);
    },
    TreeD() {
      if (this.IfShow >= 1) {
        this.IfShow = 0;
        this.ImgSrc = require("../../assets/images/zuo@3x.png");
      } else {
        this.IfShow++;
        this.ImgSrc = require("../../assets/images/shouhui@3x.png");
      }
    },
    getUserOffice() {
      let obj = {
        treeGroup: 1,
        officeType: "3",
        grade: "3",
      };
      this.$http
        .post(this.$requestUrl.GET_USER_OFFICE_TREE, obj)
        .then((res) => {
          let data = res.data.data;
          let newDate = [];
          if (data) {
            for (let i = 0; i < data.length; i++) {
              if (data[i].type === "3") {
                delete data[i].children;
              }
              newDate.push(data[i]);
            }
            console.log(newDate);
            this.osData = newDate;
          }
        })
        .catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR);
        });
    },
  },
  mounted() {
    this.getUserOffice();
  },
};
</script>

<style scoped lang="scss">
.osBody {
  height: 720px;
  float: left;
  margin-right: 1%;
  margin-top: -14px;

  .osTree {
    width: 220px;
    height: 720px;
    position: relative;
  }

  .osTreeOne {
    width: 20px;
    height: 720px;
    position: relative;
  }
}

.TreeDiv {
  width: 20px;
  height: 60px;
  border-radius: 10px;
  z-index: 500;
  position: absolute;
  top: 45%;
  right: -17px;
}

.TreeDivOne {
  width: 25px;
  height: 70px;
  border-radius: 10px;
  z-index: 500;
  position: absolute;
  top: 45%;
  left: -3px;
}

.ElTree {
  z-index: 500;
  height: 720px;
  // overflow-x: scroll;
}

.TreeTop {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #fff;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}
</style>